export default {"src":"/org/_next/static/media/room.e2b9357f.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};